<template>
  <div
    :class="[
      'flex items-center justify-between bg-white p-2 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]',
      variant === 'absolute' ? 'absolute bottom-0 left-0 right-0 z-10' : 'shrink-0'
    ]"
    data-testid="pinning-artboard-actions"
  >
    <div class="flex items-center">
      <button
        type="button"
        class="text-gray-400! hover:text-gray-500! [font-family:inherit]! text-sm! cursor-pointer border-none bg-transparent p-0 font-normal hover:underline"
        data-testid="escape-hatch-button"
        @click="emit('escape-hatch-click')"
      >
        Use classic edit form
      </button>
    </div>
    <div class="flex shrink-0 items-center gap-2.5">
      <button
        type="button"
        class="shrink-0 cursor-pointer rounded-[8px] border border-[#414192] bg-white px-3.5 py-2 text-base font-semibold [font-family:inherit] disabled:pointer-events-none disabled:opacity-25"
        style="color: #414192"
        :disabled="isCancelDisabled"
        data-testid="pinning-cancel"
        @click="emit('cancel')"
      >
        Cancel
      </button>
      <div class="relative inline-flex">
        <button
          type="button"
          class="shrink-0 cursor-pointer rounded-[8px] border border-[#414192] bg-[#414192] px-3.5 py-2 text-base font-semibold !text-white [font-family:inherit] disabled:pointer-events-none disabled:opacity-25"
          :disabled="isDoneDisabled"
          data-testid="pinning-done"
          @click="emit('done')"
        >
          {{ isLoading ? "Completing..." : "Done" }}
        </button>
        <button
          v-if="isDoneDisabled"
          type="button"
          class="absolute inset-0 z-10 h-full w-full cursor-pointer border-none bg-transparent opacity-0"
          aria-label="Button is disabled because of an unfinished pin"
          data-testid="pinning-done-disabled-overlay"
          @click="emit('done-disabled-click')"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: "PinningActionBar" });

defineProps({
  isCancelDisabled: { type: Boolean, default: false },
  isDoneDisabled: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false },
  isDesktop: { type: Boolean, default: false },
  variant: { type: String, default: "absolute" }
});

const emit = defineEmits(["cancel", "done", "done-disabled-click", "escape-hatch-click"]);
</script>
